import { connect } from 'react-redux'
import { actions } from '@opallabs/wormhole'
import ContentExport from '.'

const mapStateToProps = (state) => {
  return {
    rowCount: state.csvRowCount || 0,
    workspaceId: state.current_workspace_id,
  }
}

const mapDispatchToProps = (dispatch) => ({
  getRowCount: (params) => {
    dispatch(actions.getCSVRowCount(params))
  },
  createCSV: (params) => {
    const postParams = {
      brand_id: params.brandId,
      data_type: params.dataType,
      sort: params.sort,
      filter_attributes: params.filterAttributes,
    }
    dispatch(actions.createCSV(postParams))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(ContentExport)
